<template>
  <div id="app" style="height: 100%;" v-cloak >
    <transition name="router">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import util from './service/utils';

  import ServiceUtils from "./service/ServiceUtils";
  import ServiceHttp from "./service/ServiceHttp";
  function getQueryVariable (variable) { // 方法获取url后面的参数
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] == variable){return pair[1];}
    }
    return '';
  }
  export default {
    name: 'App',
    created(){
      let route = getQueryVariable('r');
      route = decodeURIComponent(route);
      console.log("route::",route);
      if(route){//正式
        this.$router.replace({path:route});
      }else {
        //测试
        let params = this.$route.params ;
        ServiceUtils.config.sellerId = params.sellerId;
        var url = '/choose/{0}'.format(ServiceUtils.config.sellerId);
        this.$router.replace({path:url});
        ServiceHttp.testLogin();
      }
      //url参数
      // document.body.addEventListener('touchmove', function (e) {
      //   e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
      // }, {passive: false})
    }
  }
</script>
<style>
 #map2{
   display: none;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue